export const login_i18n = {
  // Brand panel on the sign-in screen. Short and concrete: what the
  // product does, not how well it does it.
  panelKicker: "WACheckin · 2026",
  panelCta: "Discover WACheckin",
  partnersLabel: "Connected with",
  // Cards in the panel scene.
  escena: {
    reservas: "Bookings",
    mensajes: "Automated messages",
    llaves: "Digital keys",
    checkin: "Online check-in",
    cobros: "Automated payments",
    autoridades: "Authorities & compliance",
  },

  // Step 2: the code that arrives by email.
  verify: {
    title: "Check your email",
    titleWhatsapp: "Check your WhatsApp",
    sending: "Sending…",
    destinoWhatsapp: "It will be sent to",
    destinoCorreo: "It will be sent to",
    intro: "We've sent a {largo}-digit code to",
    submit: "Sign in",
    submitting: "Checking...",
    back: "Use another account",
    resendAsk: "Didn't get it?",
    resend: "Resend code",
    resendWait: "Resend in {s}s",
    resendDone: "We've sent you a new code.",
    expires: "The code expires in {tiempo}",
    expired: "The code has expired. Request a new one.",
    digitAria: "Digit {n} of {total}",
    otroMetodo: "Didn't get the email?",
    porWhatsapp: "Get it on WhatsApp",
    preferesCorreo: "Prefer email?",
    porCorreo: "Get it by email",
    introWhatsapp: "We've sent a {largo}-digit code via WhatsApp to",
    enviadoWhatsapp: "We've sent you the code on WhatsApp.",
  },
  langLabel: "Language",
  panelTitle: "All your properties, automated with AI",
  panelDesc: "Check-in, messages, keys, payments and police reporting. One panel for all of it.",

  bannerAlt: "login background",
  brandAlt: "WA Checkin",
  footerLogoAlt: "WA Checkin",
  togglePasswordAria: "toggle password visibility",

  title: "Welcome back!",
  infoTitle: "If you already have an account, sign in with your email.",
  infoDesc: "If you don’t have an account yet, you can register at the bottom.",

  emailLabel: "Email",
  emailPlaceholder: "Enter your email",

  passwordLabel: "Password",
  passwordPlaceholder: "Enter your password",

  forgot: "Forgot your password?",

  submit: "Sign in",
  submitting: "Signing in...",

  noAccount: "Don't have an account?",
  signup: "Sign up",

  terms: "Terms",
  privacy: "Privacy policy",
  copyright: "© 2024–{anio} WA Checkin. All rights reserved.",

  resetSuccess: "We sent you an email to reset your password.",

  errors: {
    default: "Login failed.",
    network: "Connection error. Please try again.",
  },
  resetPassword: {
    title: "Reset password",
    infoTitle: "We will email you a reset link",
    infoDesc:
      "Enter your email and you will receive instructions to reset your password.",

    labels: {
      email: "Email address",
    },

    placeholders: {
      email: "name@email.com",
    },

    hints: {
      email: "Make sure you enter the email you used to sign up.",
    },

    buttons: {
      send: "Send",
      sending: "Sending...",
    },

    successTitle: "Done!",
    successDesc: "Check your inbox (and spam).",

    aria: {
      close: "close",
    },

    toasts: {
      emailRequired: "Please enter your email.",
      sent: "We sent an email with instructions.",
      userNotFound: "User not found.",
      networkError: "Connection error. Please try again.",
    },
  },

  
  common: {
    ok: "OK",
    cancel: "Close",
  },
};
